export default __webpack_public_path__ + "static/media/media_vividlipi.89957238.pdf";